module.exports = {
	"textures": [
		{
			"image": "LuckyNumberJackpot",
			"format": "RGBA8888",
			"size": {
				"w": 789,
				"h": 2024
			},
			"scale": 1,
			"frames": [
				{
					"filename": "1.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 64,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 0,
						"y": 0,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "2.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 64,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 0,
						"y": 92,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "3.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 64,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 0,
						"y": 184,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "4.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 64,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 0,
						"y": 276,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "5.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 64,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 0,
						"y": 368,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "6.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 64,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 0,
						"y": 460,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "7.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 64,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 0,
						"y": 552,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "8.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 64,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 0,
						"y": 644,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "9.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 64,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 0,
						"y": 736,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "10.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 64,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 0,
						"y": 828,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "11.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 64,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 0,
						"y": 920,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "12.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 64,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 0,
						"y": 1012,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "13.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 64,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 0,
						"y": 1104,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "14.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 64,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 0,
						"y": 1196,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "15.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 64,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 0,
						"y": 1288,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "16.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 64,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 0,
						"y": 1380,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "17.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 64,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 0,
						"y": 1472,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "18.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 64,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 0,
						"y": 1564,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "19.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 64,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 0,
						"y": 1656,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "20.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 64,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 0,
						"y": 1748,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "21.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 64,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 0,
						"y": 1840,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "22.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 64,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 0,
						"y": 1932,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "23.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 64,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 263,
						"y": 0,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "27.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 73,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 263,
						"y": 92,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "28.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 73,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 263,
						"y": 184,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "29.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 73,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 263,
						"y": 276,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "30.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 73,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 263,
						"y": 368,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "31.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 73,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 263,
						"y": 460,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "32.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 73,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 263,
						"y": 552,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "33.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 73,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 263,
						"y": 644,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "34.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 73,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 263,
						"y": 736,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "35.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 73,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 263,
						"y": 828,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "36.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 73,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 263,
						"y": 920,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "37.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 73,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 263,
						"y": 1012,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "38.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 73,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 263,
						"y": 1104,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "39.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 73,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 263,
						"y": 1196,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "40.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 73,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 263,
						"y": 1288,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "41.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 73,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 263,
						"y": 1380,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "42.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 73,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 263,
						"y": 1472,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "43.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 73,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 263,
						"y": 1564,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "44.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 73,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 263,
						"y": 1656,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "45.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 73,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 263,
						"y": 1748,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "46.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 73,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 263,
						"y": 1840,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "47.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 73,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 263,
						"y": 1932,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "48.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 73,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 526,
						"y": 0,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "49.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 73,
						"y": 4,
						"w": 263,
						"h": 92
					},
					"frame": {
						"x": 526,
						"y": 92,
						"w": 263,
						"h": 92
					}
				},
				{
					"filename": "24.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 68,
						"y": 4,
						"w": 259,
						"h": 92
					},
					"frame": {
						"x": 526,
						"y": 184,
						"w": 259,
						"h": 92
					}
				},
				{
					"filename": "26.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 73,
						"y": 4,
						"w": 259,
						"h": 92
					},
					"frame": {
						"x": 526,
						"y": 276,
						"w": 259,
						"h": 92
					}
				},
				{
					"filename": "25.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 73,
						"y": 4,
						"w": 254,
						"h": 92
					},
					"frame": {
						"x": 526,
						"y": 368,
						"w": 254,
						"h": 92
					}
				},
				{
					"filename": "0.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 400,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 64,
						"y": 4,
						"w": 263,
						"h": 91
					},
					"frame": {
						"x": 526,
						"y": 460,
						"w": 263,
						"h": 91
					}
				}
			]
		}
	],
	"meta": {
		"app": "http://free-tex-packer.com",
		"version": "0.6.7"
	}
};